import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { Tag } from 'antd';

const StatusBadge = ({
    status = "UNKNOWN",
    icon = undefined,

}) => {
    // primary, secondary, success, danger, warning, info, light, dark
    const [theme, setTheme] = useState();

    useEffect(() => {

        switch (status.length > 0 ? status : "UNKNOWN") {
            case "DEACTIVATED":
            case "OPEN":        // for invoice status.
                setTheme("geekblue");
                break;
            case "DRAFT":
            case "CONCEPT":
            case "PENDING_VALIDATION":
            case "RENTED_OUT":
                setTheme("gold");
                break;
            case "DELETED":
            case "DISABLED":
            case "UNPAID":
            case "ERROR":
            case "UPDATE_ERROR":
            case "OVER_DUE":    // for invoice status.
            case "MAINTENANCE":
            case "RENTED_OUT_TO_LATE":
                setTheme("magenta");
                break;
            case "ERROR_CREATE":
            case "REFUND":
            case "DEFECT":
            case "PAYMENT_FAILED":
            case "RENTED_OUT_PENDING":
                setTheme("red")
                break;
            case "ACTIVE":
            case "ONLINE":
            case "ENABLED":
            case "PAID":
            case "AVAILABLE":
            case "AVAILBLE":
            case "BESCHIKBAAR":
            case "CLOSED":
            case "CLOSED_ACCOUNT_DELETED":
            case "APPROVED":
            case "PAYMENT_SUCCESS":
                setTheme("green");
                break;
            case "REFUND_INITIATED":
            case "REFUNDED":
            case "PARTIAL_REFUNDED":
            case "ON_HOLD":
                setTheme("orange");
                break;
            default:
                setTheme("purple");
                break;
        }

        return () => {
            // cleanup
        }
    }, [status])

    return (
        <Tag color={theme}>
            {icon} <FormattedMessage id={status} />
        </Tag>
    );
};

export default StatusBadge;